import { TreeDataNode } from "antd";

export const dataTypeTreeDataForDataInfo: TreeDataNode[] = [
  { title: "Name of Uploader", key: "Data Source Info_Name of Uploader", isLeaf: true },
  { title: "Primary Data Source", key: "Data Source Info_Primary Data Source", isLeaf: true },
  { title: "Filing Date", key: "Data Source Info_Filing Date", isLeaf: true },
  { title: "Filing Type", key: "Data Source Info_Filing Type", isLeaf: true },
  { title: "Filing Link", key: "Data Source Info_Filing Link", isLeaf: true },
  { title: "Period End", key: "Data Source Info_Period End", isLeaf: true },
  { title: "Period End Date", key: "Data Source Info_Period End Date", isLeaf: true },
  { title: "Financial Year", key: "Data Source Info_Financial Year", isLeaf: true },
  { title: "Financial Year Date", key: "Data Source Info_Financial Year Date", isLeaf: true },
  { title: "Financial Statement Currency", key: "Data Source Info_Financial Statement Currency", isLeaf: true },
  { 
    title: "Numerical Scale",
    key: "Data Source Info_Numerical Scale", 
    children: [
      { title: "Share Counts", key: "Data Source Info_Numerical Scale_Share Counts", isLeaf: true },
      { title: "Currency Values", key: "Data Source Info_Numerical Scale_Currency Values", isLeaf: true },
      { title: "Share Price", key: "Data Source Info_Numerical Scale_Share Price", isLeaf: true },
    ],
  },
  { title: "Comments", key: "Data Source Info_Comments", isLeaf: true },
];

